import { Button } from "@mui/material";

export default function RedButton({ onClick, disabled, text, style }: { onClick: () => void; disabled: boolean; text: string; style?: {} }) {
  return (
    <Button
      sx={{
        ...style,
        //  ml: "auto",
        backgroundColor: "primary.main",
        "&:hover": {
          backgroundColor: "primary.hover",
        },
        alignSelf: "center",
        // marginTop: "10px",
      }}
      variant="contained"
      disableElevation
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}
